import { CompanyNameDocument } from '../../graphql/graphql';

export const companyNameQuery = CompanyNameDocument;
